export default __webpack_public_path__ + "static/media/monsmini.89631729.jpg";